import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ItemClassEdit } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const ItemClassInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.item_class);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Item Class Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Label</TableCell>
              <TableCell>{model.label}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Reference</TableCell>
              <TableCell>{model.reference}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Denomination</TableCell>
              <TableCell>{model.denomination}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Expire Duration</TableCell>
              <TableCell>{model.expire_duration/86400+ ' day'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <ItemClassEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

ItemClassInfo.propTypes = {
  className: PropTypes.string,
};

export default ItemClassInfo;
